import { OfflineModel } from './OfflineModel';
import { ParticipationResponseData } from './response-data';
import { ResponseInfo } from './response-info';
import { CommonSetting, PreviewData, SignUp } from './survey';

export class SurveyProperties {
  key: string;
  Lang: number;
  intVOSurveyID: number;
  intVOSurveyNo: number;
  intVOCorpNo: number;
  SACID: number;
  isAssessmentOrSurvey: string;
  isPublicSurvey: boolean;
  JavaScriptDisableTitle: string;
  JavaScriptDisable: string;
  isAssessmentSurvey: boolean;
  recno: number;
  strDir: string;
  isThankYou: boolean;
  noByPassLogic: number;
  noShowHiddenQN: number;
  noManditorySkip: number;
  previewSurveyFormat: string;
  IpadPreview: boolean;
  strCultureInfo: string;
  isThankYouPageEnable: boolean;
  strRef: string;
  strPrimLangID: string;
  ParticipationResponseData: ParticipationResponseData;
  strSurveyCSS: string;
  strSurveyJS: string;
  strCustomWork: string;
  QueryStringData: string;
  strQueryString: string;
  PM_Survey_EstimatedTime: string;
  commonSetting: CommonSetting;
  offlineModel: OfflineModel;
  signUp: SignUp;
  previewData: PreviewData;
  strThirdPartyMails: string;
  responseInfo: ResponseInfo;
  blnPartiallySupported: boolean;
  isASorSON: boolean;
  publicCookieRecNo: string;
  isAuthenticationNeeded: boolean;
  Screen_Resolution: string;
  PoweredByLogotxt: string;
  isErrorRedirect: boolean;
  RedirectURL: string;
  Restrictedby: string;
  isShowConsent: boolean;
  SocialMediaMeta: SocialMediaMetaModel;
}

export class SocialMediaMetaModel {
  Url: string;
  Type: string;
  Title: string;
  Description: string;
  ImageUrl: string;
  Platform: string;
}

export class AdvanceBranchingModel {
  PM_advbraElse: boolean;
  PM_advbraElseZarcaID: string;
  PM_AdvanceBranchingElsePageNo: string;
  PM_AdvanceBranchingElseRuleID: string;
  PM_branchQ: string;
  PM_advbraZarcaQID: number;
  PM_AdvanceBranchingPageNo: string;
  PM_AdvanceBranchingRuleID: string;
}

export class SurveySearchModel {
  key: string;
  lang: number;
  responseID: string;
  sacid: string;
  QueryStringData: string;
  isReopen: boolean;
  isEmbedMobile: boolean;
  isEmbedPopMobile: boolean;
  isEmbedPopWeb: boolean;
  embedlangOpt: number;
  publicCookieRecNo: string;
  status: string;
  isThankYou: boolean;
  type: string;
  msgId: number;
  isPartialEmbed: boolean;
  isPartial: boolean;
  Dir: string;
  OUid: string;
  data: string;
  isGoBackQuota: boolean;
  frm: string;
  SocialEmail: string;
  viewPort: string;
  surveyQueryString: string;
  Tick: string;
  isMerr: string;
  StateReader: string;
  intelMatrix: string;
  isAssessmentSubmit: boolean;
  pageNo: number;
  isAutoSave: boolean;
  surveyProperties: SurveyProperties;
  langPop: boolean;
  isBlockedByCookie: boolean;
  islangauageChange: boolean;
  auth:boolean;
  surveyLink: string;
  surveyDomain: string;
}

export class SurveyDecodeSearchModel {
  k: string;
  imageFolder: string;
  strClienturl: string;
  isReopen: boolean;
  participationkeyFolder: string;
  cn: string;
  prlang: string;
  err: string;
  lang: number;
  staticHost: string;
  supportEmail: string;
}
